import React, { useState } from 'react';
import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import ConversationTemp from 'component/organism/conversation/ConversationTemp';
import TourModal from 'component/hoc/tour-modal/TourModal';
import { useTour } from 'app-context/tourContext/TourContext';
import RoundedTabs from 'component/atom/Tabs/RoundedTabs';

const Conversations = () => {
  const [isRefetch, setIsRefetch] = useState(null);
  const [isTryMe, setIsTryMe] = useState(0);
  const { showModal } = useTour();

  const tabs = [
    {
      label: 'Bot',
    },
    {
      label: 'Try Me',
    },
  ];

  const rightItem = (
    <div>
      <RoundedTabs tabs={tabs} activeTab={isTryMe} setActiveTab={setIsTryMe} />
    </div>
  );
  return (
    <>
      <SettingsHeader title="Conversations" rightItem={rightItem} />
      <ConversationTemp isRefetch={isRefetch} isTryMe={isTryMe} />
      {showModal && <TourModal />}
    </>
  );
};

export default Conversations;
